import { createModuleLayout } from "@/lib/create-module-layout";
import { MODULES } from "@kubdee/shared/module-ids";
import carRentalModule from "@kubdee/module-car-rental";

export default createModuleLayout({
  moduleId: MODULES.CAR_RENTAL,
  moduleConfig: carRentalModule,
  sidebarInsetClassName: "flex flex-col h-svh min-w-0 overflow-hidden",
});
